import { upperFirstEveryWord } from './stringUtils';

export interface FormattedAddress {
  formattedAddress: string;
  formattedCityState: string;
  formattedCityStateZip: string;
  formattedCompleteAddress: string;
  formattedName: string;
  formattedStreet: string;
}

interface AddressComponent {
  street: string;
  city: string;
  state: string;
  unit?: string;
  zip: string;
  name?: string;
  listingName?: string;
}

export const formatAddress = (addressComponents: AddressComponent): FormattedAddress => {
  const { street, city, state, unit, name, zip, listingName } = addressComponents;

  // Transformations
  let formattedStreet = street ? upperFirstEveryWord(street) : '';
  const formattedCity = city ? upperFirstEveryWord(city) : '';
  const formattedState = state ? state : '';
  const formattedUnit = unit ? unit.toUpperCase() : '';
  const formattedName = upperFirstEveryWord(name || listingName || '');

  if (unit && unit.length) {
    formattedStreet += ` ${formattedUnit}`;
  }

  const formattedAddress = [formattedStreet, formattedCity, formattedState].filter((val) => val).join(', ');
  const formattedCityState = [formattedCity, formattedState].filter((val) => val).join(', ');
  const formattedCityStateZip = `${formattedCityState} ${zip}`;
  const formattedCompleteAddress = [`${formattedStreet},`, formattedCityState, zip].filter((val) => val).join(' ');

  return {
    formattedAddress,
    formattedCityState,
    formattedCityStateZip,
    formattedCompleteAddress,
    formattedName,
    formattedStreet,
  };
};
